// @ts-expect-error untyped
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import styled from 'styled-components';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { Flex } from 'foundations-components/components/Flex';
import { ChangedDealAmountTag, NewDealAmountTag, RemovedDealAmountTag } from '../../dealHistory/DealAmountHistory';
import { CURRENCY_PRECISION } from '../../../constants/Currency';
import { DealStageHistory } from '../../dealHistory/DealStageHistory';
import { AmountChangeEvent } from '../../../types/api/deals';
import { TEN_MIN_IN_MS, THIRTY_DAYS_IN_MS } from '../../../constants/DealHistoryConstants';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAvatarWrapper = styled.span.withConfig({
  displayName: "DealSidebarCardPropertiesSection__StyledAvatarWrapper",
  componentId: "g0zb37-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    lineHeight: theme.space['250'],
    marginRight: theme.space['200']
  };
});
const renderDealAmountTag = deal => {
  var _deal$properties$amou, _deal$properties;
  const history = deal.history;

  //in case we have a deal where the amount has been fully removed, we need to check for both history and the amount property itself
  if (!history || !history.hs_amount_change_event || history.hs_amount_change_event === AmountChangeEvent.UNCHANGED || !deal.properties.amount) {
    return null;
  }

  //The history audits endpoint has a latency of 5-10 minutes, so this ensures that we don't display dated values
  const wasModifiedInLastTenMinutes = deal.properties.hs_lastmodifieddate && deal.properties.hs_lastmodifieddate.value ? Date.now() - Number(deal.properties.hs_lastmodifieddate.value) < TEN_MIN_IN_MS : false;
  const wasModifiedInLastMonth = Date.now() - ((_deal$properties$amou = deal === null || deal === void 0 || (_deal$properties = deal.properties) === null || _deal$properties === void 0 || (_deal$properties = _deal$properties.amount) === null || _deal$properties === void 0 ? void 0 : _deal$properties.timestamp) !== null && _deal$properties$amou !== void 0 ? _deal$properties$amou : 0) < THIRTY_DAYS_IN_MS;
  const dealCreatedInPeriodOrNotUpdatedInPeriod = history.hs_created_in_period || wasModifiedInLastTenMinutes || !wasModifiedInLastMonth;
  if (dealCreatedInPeriodOrNotUpdatedInPeriod) {
    return null;
  }
  if (history.hs_amount_change_event === AmountChangeEvent.NEW) {
    return /*#__PURE__*/_jsx(NewDealAmountTag, {});
  }
  if (history.hs_amount_change_event === AmountChangeEvent.REMOVED) {
    return /*#__PURE__*/_jsx(RemovedDealAmountTag, {});
  }
  const changePercentage = history.hs_amount_change_percentage;
  if (history && changePercentage !== undefined && Math.abs(changePercentage) >= 1) {
    return /*#__PURE__*/_jsx(ChangedDealAmountTag, {
      changePercentage: changePercentage
    });
  }
  return null;
};
const renderDealStageHistory = deal => {
  var _deal$properties$deal, _deal$properties2;
  const history = deal.history;
  if (!(history !== null && history !== void 0 && history.hs_deal_stage_progress) || !deal.properties.dealstage) {
    return null;
  }
  const wasModifiedInLastMonth = Date.now() - ((_deal$properties$deal = deal === null || deal === void 0 || (_deal$properties2 = deal.properties) === null || _deal$properties2 === void 0 || (_deal$properties2 = _deal$properties2.dealstage) === null || _deal$properties2 === void 0 ? void 0 : _deal$properties2.timestamp) !== null && _deal$properties$deal !== void 0 ? _deal$properties$deal : 0) < THIRTY_DAYS_IN_MS;
  if (history.hs_created_in_period || !wasModifiedInLastMonth || history.hs_deal_stage_progress.toString() === AmountChangeEvent.UNCHANGED) {
    return null;
  }
  return /*#__PURE__*/_jsx(DealStageHistory, {
    stageProgress: history.hs_deal_stage_progress,
    showText: false
  });
};
const AmountProperty = ({
  amount,
  currencyCode,
  deal
}) => {
  const dealAmountTag = renderDealAmountTag(deal);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedIntlCurrency, {
      value: amount,
      precision: CURRENCY_PRECISION,
      currencyCode: currencyCode
    }), ' ', dealAmountTag || /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      as: "span"
    })]
  });
};
export const DealSidebarCardPropertiesSection = ({
  amount,
  currencyCode,
  deal,
  dealStageLabel,
  email,
  ownerName
}) => {
  const amountProperty = /*#__PURE__*/_jsx(AmountProperty, {
    amount: amount,
    currencyCode: currencyCode,
    deal: deal
  });
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [email && /*#__PURE__*/_jsx(StyledAvatarWrapper, {
      children: /*#__PURE__*/_jsx(UIAvatar, {
        hubSpotUserEmail: email,
        size: "xxs",
        displayName: ownerName || email
      })
    }), email ? /*#__PURE__*/_jsx(View, {
      borderInlineStartColor: "border-primary-default",
      borderInlineStartStyle: "solid",
      borderInlineStartWidth: "100",
      paddingInlineStart: "300",
      children: amountProperty
    }) : amountProperty, /*#__PURE__*/_jsxs(View, {
      borderInlineStartColor: "border-primary-default",
      borderInlineStartStyle: "solid",
      borderInlineStartWidth: "100",
      paddingInlineStart: "300",
      children: [`${dealStageLabel} `, renderDealStageHistory(deal)]
    })]
  });
};